import { useEffect, useState } from 'react';
import { readJsonStorage, writeJsonStorage } from './listViewStorage';

function readStored(key, fallback, legacyKey) {
    const stored = readJsonStorage(localStorage, key, null);
    if (stored != null) {
        return stored;
    }
    if (legacyKey) {
        return readJsonStorage(localStorage, legacyKey, fallback);
    }
    return fallback;
}

function mergeRecord(defaults, stored) {
    if (stored == null) {
        return defaults;
    }
    if (defaults && typeof defaults === 'object' && !Array.isArray(defaults) && typeof stored === 'object' && !Array.isArray(stored)) {
        return { ...defaults, ...stored };
    }
    return stored;
}

export function usePersistedListParams({
    keys = {},
    defaults = {},
    legacyKeys = {},
} = {}) {
    const [filters, setFilters] = useState(() => (
        mergeRecord(defaults.filters, readStored(keys.filters, null, legacyKeys.filters))
    ));

    const [sortBy, setSortBy] = useState(() => (
        mergeRecord(defaults.sortBy, readStored(keys.sortBy, null, legacyKeys.sortBy))
    ));

    const [displayMode, setDisplayMode] = useState(() => {
        if (!keys.displayMode && !legacyKeys.displayMode) {
            return defaults.displayMode ?? null;
        }
        return readStored(keys.displayMode, defaults.displayMode ?? null, legacyKeys.displayMode)
            ?? defaults.displayMode
            ?? null;
    });

    useEffect(() => {
        if (keys.filters) {
            writeJsonStorage(localStorage, keys.filters, filters);
        }
    }, [filters, keys.filters]);

    useEffect(() => {
        if (keys.sortBy) {
            writeJsonStorage(localStorage, keys.sortBy, sortBy);
        }
    }, [sortBy, keys.sortBy]);

    useEffect(() => {
        if (keys.displayMode && displayMode != null) {
            writeJsonStorage(localStorage, keys.displayMode, displayMode);
        }
    }, [displayMode, keys.displayMode]);

    return {
        filters,
        setFilters,
        sortBy,
        setSortBy,
        displayMode,
        setDisplayMode,
    };
}
